export const IS_PURCHASE_EXECUTED_FLAG = "isPurchaseExecutedFlag";
export const IS_SEATS_REQUEST = "iSSeatsRequest";
export const IS_SELECTED_SEATS = "isSelectedSeats";
export const IS_SELECTED_SERVICES = "isSelectedServices";
export const INITIAL_SALE_EVENT_CONTEXT = "initialSaleEventContext";
export const UTIL_CART = "utilCart";